import { Component } from "react";

// Card padrão das telas.
//
// A barra de ações vai para o cabeçalho quando o card tem título: título de um lado, ação
// principal do outro, na mesma linha. Antes elas entravam acima do conteúdo, empurrando a
// tabela para baixo e deixando o cabeçalho vazio ao lado do título.
//
// Sem título não há cabeçalho onde encaixar, e aí as ações continuam abertura do corpo — é o
// caso do card de rodapé dos formulários, que só tem "Voltar" e o submit.
export default class BetterBox extends Component {
    render() {
        const hasHead = Boolean(this.props.title || this.props.subtitle);
        const hasActions = Boolean(this.props.actions);

        return (
            <div className="kt-portlet">
                {hasHead ? (
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                {this.props.title}
                                {this.props.subtitle ? <small>{this.props.subtitle}</small> : null}
                            </h3>
                        </div>

                        {hasActions ? <div className="kt-portlet__head-toolbar">{this.props.actions}</div> : null}
                    </div>
                ) : null}

                <div className="kt-portlet__body">
                    <div className="kt-portlet__preview">
                        <div>
                            {hasActions && !hasHead ? (
                                <div>
                                    {this.props.actions}
                                    <div className="kt-separator kt-separator--dashed"></div>
                                </div>
                            ) : null}

                            {this.props.children ? <div className="kt-section__content">{this.props.children}</div> : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
